import { TabKeys } from "../../data/tabs";
import { MenuItemProps } from "./menu-item/MenuItem.component";

export interface MenuItem extends MenuItemProps {
  index: number;
}

export const mainMenu: MenuItem[] = [
  {
    index: 1,
    title: "Home",
    icon: false,
    disabled: false,
    tabKey: TabKeys.Home,
  },
  {
    index: 2,
    title: "Journey",
    icon: false,
    disabled: false,
    tabKey: TabKeys.Specialties,
  },
  {
    index: 3,
    title: "Contact",
    icon: false,
    disabled: false,
    tabKey: TabKeys.Contact,
  },
];
